import { isNil, negate } from 'lodash';

export function fullName(...names: Array<string | undefined | null>) {
  return names
    .filter(negate(isNil))
    .join(' ')
    .trim();
}
